export enum LegajosBusqueda {
    Solicitudes = 0,
    Aerovales = 1,
    Aprobacion_o_rechazo = 2
}